import { Directive, forwardRef, OnInit, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Ag1ChipComponent } from '../components/ag1-chip/ag1-chip.component';

@Directive({
  selector: 'ag1-chip',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Ag1ChipValueAccessorDirective),
      multi: true,
    },
  ],
})
export class Ag1ChipValueAccessorDirective
  implements ControlValueAccessor, OnInit
{
  private host = inject(Ag1ChipComponent);

  constructor() {}

  private onChange: (value: string[]) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit() {
    this.host.chipsChange.subscribe((chips) => {
      this.onChange(chips);
    });
  }

  writeValue(value: string[]): void {
    if (value) {
      this.host.chips = value;
    }
  }

  registerOnChange(fn: (value: string[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle the disabled state if necessary
  }
}
